import { QueryKey, useQuery } from '@tanstack/react-query';
import Api from 'Api/Api';
import { url } from '@api-config';
import { IDataSourceItem } from 'Modules/Studio/DataSources/redux/initialState';

export const IngestionDataSourceQueryKey = ['IngestionDataSourceQuery'];

export interface IIngestionDataSourceList {
  used: IDataSourceItem[];
  unUsed: IDataSourceItem[];
}

export const useIngestionDataSourceList = (searchTerm?: string) => {
  return useQuery<IIngestionDataSourceList, Error, IIngestionDataSourceList, QueryKey>({
    queryKey: IngestionDataSourceQueryKey,
    queryFn: (): Promise<IIngestionDataSourceList> => Api.get(`${url.dataSource}?onlyMapped=true`),
    staleTime: Infinity,
    gcTime: 1 * 60 * 1000, // 1 minutes
    select(data) {
      if (!searchTerm) {
        return data;
      }

      return {
        used: data.used?.filter((item) => item.name.toLowerCase().includes(searchTerm)) || [],
        unUsed: data.unUsed,
      };
    },
  });
};
